<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_WorkReport001
 * @created at      :   2025/09/26
 * @created by      :   ANS901 – hainn@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import { mapMutations, mapState, mapActions } from 'vuex';
import store from '@/store';
import APP_WorkReport001_store from '@/views/mobile/app_work_report/APP_WorkReport001/store';
import AnsPanel from '@/components/ansPanel/index.vue';
import APP_WorkReport002 from '@/views/mobile/app_work_report/APP_WorkReport002';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import PopupMST007 from '@/views/popupSearch/PopupMST007/store';
import PopupFIL030 from '@/views/popupSearch/PopupFIL030/store';
import PopupSystem001Store from '@/views/popupSearch/PopupSystem001/store';
import { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import template from './template.html';
import './style.scss';
import helpers from '@/utils/helpers';

var APP_WorkReport001 = {
    template: template,
    components: {
        AnsPanel,
        APP_WorkReport002,
        PopupMST005,
        PopupMST007,
        PopupFIL030,
        PopupSystem001Store
    },
    beforeCreate() {
        if (!store.hasModule('APP_WorkReport001')) {
            store.registerModule('APP_WorkReport001', APP_WorkReport001_store);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
        if (!store.hasModule('PopupMST007')) {
            store.registerModule('PopupMST007', PopupMST007);
        }
        if (!store.hasModule('PopupFIL030')) {
            store.registerModule('PopupFIL030', PopupFIL030);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001Store);
        }
    },
    async created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        this.resetDataInit();

        this.referCompany(0, this.user.company_cd);
        await this.loadOptions();

        const today = new Date();
        const formatted = today.getFullYear() + '/' + String(today.getMonth() + 1).padStart(2, '0') + '/' + String(today.getDate()).padStart(2, '0');
        this.data.working_date_start = formatted;
        this.data.working_date_end = formatted;
        await this.referAreaInfo(0, this.user.department_cd);
    },
    mounted() {
        this.setHeader(this.header);
        window.addEventListener('resize', this.handleResize);
    },
    unmounted() {
        this.setHeader();
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            screenId: 'APP_WorkReport001',
            rowActive: null,
            showDetail: false,
            windowWidth: 0,
            type: 1,
            companyCD: '',
            workReportID: '',
            sort: {
                user: '',
                type: '',
                office: '',
                working_date: '',
                title_1: '',
                msg: ''
            }
        };
    },
    watch: {
        showDetail(val) {
            if (!val) {
                this.setHeader(this.header);
            }
        },
        'data.company_cd'(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loadOptions();
            }
        }
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('APP_WorkReport001', ['data', 'options', 'paginationData', 'searchData', 'dataSelect']),
        header() {
            return {
                title: '業務日報一覧',
                topButtons: []
            };
        },
        isMobile() {
            return helpers.checkIfMobile();
        },
        isIpad() {
            return !(this.windowWidth > 768 && this.windowWidth <= 1366);
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapMutations('APP_WorkReport001', ['resetDataInit']),
        ...mapActions('APP_WorkReport001', ['actionSearch']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupMST007', ['searchOfficeInfo']),
        ...mapActions('PopupFIL030', ['searchFil030Info']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),

        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        addNew() {
            this.showDetail = true;
            this.CompanyCD = '';
            this.workReportID = '';
        },
        referDetail(mode) {
            if (typeof mode === 'number') {
                this.type = mode;
            }
            this.showDetail = !this.showDetail;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async loadOptions() {
            try {
                const [title_1] = await Promise.all([
                    helpers.getDataSys005({ meisho_cd: 200, company_cd: this.data.company_cd ?? this.user.company_cd })
                ]);
                this.dataSelect.title_1 = (title_1 || []).map((item) => ({ code: item.code ?? '', name: item.name ?? '' }));
            } catch (e) {
                this.dataSelect.title_1 = [];
            }
        },
        referCompany(index, value) {
            if (value) {
                this.searchSystemInfo({
                    company_cd: value,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.data.company_cd = result.company_cd;
                            this.data.company_name = result.company_name;
                        } else {
                            this.data.company_cd = '';
                            this.data.company_name = '';
                            this.data.department_cd = '';
                            this.data.department_name = '';
                            this.data.office_cd = '';
                            this.data.office_name = '';
                        }
                    },
                    onError: () => {
                        this.data.company_cd = '';
                        this.data.company_name = '';
                    }
                });
            } else {
                this.data.company_cd = '';
                this.data.company_name = '';
                this.data.department_cd = '';
                this.data.department_name = '';
                this.data.office_cd = '';
                this.data.office_name = '';
            }
        },
        getCompanyName(data) {
            this.data.company_name = data;
        },
        referAreaInfo(index, value) {
            return new Promise((resolve) => {
                if (value) {
                    this.searchAreaInfo({
                        company_cd: this.data.company_cd || this.user.company_cd,
                        department_cd: value,
                        mode: 1,
                        callback: (response) => {
                            if (response.Data.data.length > 0) {
                                const result = response.Data.data[0];
                                this.data.department_cd = result.department_cd;
                                this.data.department_name = result.department_name;
                            } else {
                                this.data.department_cd = '';
                                this.data.department_name = '';
                                this.data.office_cd = '';
                                this.data.office_name = '';
                            }
                            resolve();
                        },
                        onError: () => {
                            this.data.department_cd = '';
                            this.data.department_name = '';
                            resolve();
                        }
                    });
                } else {
                    this.data.department_cd = '';
                    this.data.department_name = '';
                    this.data.office_cd = '';
                    this.data.office_name = '';
                    resolve();
                }
            });
        },
        getAreaName(data) {
            this.data.department_name = data;
        },
        referOfficeSearch(index, value) {
            if (value) {
                this.searchOfficeInfo({
                    company_cd: this.data.company_cd || this.user.company_cd,
                    department_cd: this.data.department_cd,
                    office_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.data.office_cd = result.office_cd;
                            this.data.office_name = result.office_name;
                        } else {
                            this.data.office_cd = '';
                            this.data.office_name = '';
                        }
                    },
                    onError: () => {
                        this.data.office_cd = '';
                        this.data.office_name = '';
                    }
                });
            } else {
                this.data.office_cd = '';
                this.data.office_name = '';
            }
        },
        getOfficeName(data) {
            this.data.office_name = data;
        },
        referStaffCDStart(index, value) {
            if (value) {
                this.searchFil030Info({
                    company_cd: this.data.company_cd || this.user.company_cd,
                    staff_id: value,
                    pageNo: 1,
                    pageSize: 10,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        this.data.user_id_start = result ? result.staff_id : '';
                    },
                    onError: () => {
                        this.data.user_id_start = '';
                    }
                });
            } else {
                this.data.user_id_start = '';
            }
        },
        referStaffCDEnd(index, value) {
            if (value) {
                this.searchFil030Info({
                    company_cd: this.data.company_cd || this.user.company_cd,
                    staff_id: value,
                    pageNo: 1,
                    pageSize: 10,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        this.data.user_id_end = result ? result.staff_id : '';
                    },
                    onError: () => {
                        this.data.user_id_end = '';
                    }
                });
            } else {
                this.data.user_id_end = '';
            }
        },
        search() {
            this.actionSearch({
                body: {
                    ...this.data,
                    page_no: 1,
                    page_size: this.paginationData.pageSize
                },
                callback: () => {
                    this.rowActive = null;
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.S001,
                        content: error,
                        okText: 'OK'
                    });
                }
            });
        },
        changeCurrentPage(data) {
            this.actionSearch({
                body: {
                    ...this.data,
                    page_no: data.currentPage,
                    page_size: data.perPage
                },
                callback: () => {
                    this.rowActive = null;
                },
                onError: (error) => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.S001,
                        content: error,
                        okText: 'OK'
                    });
                }
            });
        },
        sortCol(key, col) {
            this.sort = {
                user: '',
                type: '',
                office: '',
                working_date: '',
                title_1: '',
                msg: ''
            };
            this.sort[col] = key;
            this.data.sort = key;
            this.data.col = col;
            this.search();
        },
        adjustDate(days, fieldName) {
            this.data[fieldName] = helpers.adjustDate(days, this.data[fieldName]);
        },
        openDetailFromRow(item) {
            this.type = item?.mode || 1;
            this.companyCD = item?.CompanyCD || '';
            this.workReportID = item?.WorkReportID || '';
            this.showDetail = true;
        },
        isShow(item) {
            this.type = item?.mode || 1;
            this.showDetail = true;
        }
    }
};
export default APP_WorkReport001;
</script>
